import { DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from "components/roundedbutton/CustomButton";
import { useAppSelector } from "redux/hooks";

import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { theme } from "theme";
import { currencyOf } from "utils/util";
import { TipoDescontoAcrescimoAutorizador, TipoDescontoAcrescimoAutorizadorLabelDescritivo } from "./Configuracoes.model";

type AutorizaDescontoItemErrorProps = {
    valorSolicitado: React.MutableRefObject<number | null>;
    closeModalDescontoItemError: () => void;
    tipoDescontoAcrescimoAutorizador: TipoDescontoAcrescimoAutorizador;
};

const AutorizaDescontoItemError = (props: AutorizaDescontoItemErrorProps) => {
    const { descontoMaximoItem, descontoMaximoPedido, acrescimoMaximoPedido } = useAppSelector(e => e.configuracoes.configuracaoDesconto);

    return (
        <CustomDialog
            sx={{ border: 0, margin: 0, padding: 0 }}
            id="desconto-fixo-dialog"
            open={true}
            onClose={props.closeModalDescontoItemError}
            fullWidth
        >
            <DialogTitle>
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id={"desconto-acrescimo-nao-autorizado"}
                    iconClassName="fa-solid fa-percent"
                    label={(props.tipoDescontoAcrescimoAutorizador === TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO ? "Acréscimo" : 'Desconto') + ' não autorizado'}
                    small
                />
            </DialogTitle>

            <DialogContent sx={{
                display: 'flex',
                flexDirection: "column",
                gap: '6px'
            }}>

                <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                        Desconto máximo no item do usuário:
                    </span>
                    <span>
                        {descontoMaximoItem.toFixed(2)}%
                    </span>
                </Typography>

                <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                        Desconto máximo no pedido do usuário:
                    </span>
                    <span>
                        {descontoMaximoPedido.toFixed(2)}%
                    </span>
                </Typography>

                <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                        Acréscimo máximo no pedido do usuário:
                    </span>
                    <span>
                        {currencyOf(acrescimoMaximoPedido)}
                    </span>
                </Typography>

                <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between', color: theme.palette.error.main }}>
                    <span>
                        {TipoDescontoAcrescimoAutorizadorLabelDescritivo[props.tipoDescontoAcrescimoAutorizador]}:
                    </span>
                    <span>
                        {props.tipoDescontoAcrescimoAutorizador === TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO
                            ? currencyOf(props.valorSolicitado.current!)
                            : `${props.valorSolicitado.current!.toFixed(2)}%`
                        }
                    </span>
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    justifyContent: 'flex-end'
                }}>
                <CustomButton onClick={props.closeModalDescontoItemError} variant="contained" color="error">
                    fechar
                </CustomButton>

            </DialogActions>
        </CustomDialog>
    );
};
export default AutorizaDescontoItemError;
